import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const skillApi = {
  getSkills: async ({ page = 1, perPage = 10, search = '', includeTrashed = false, paginate = true } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SKILLS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false', paginate },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching skills:', error);
      throw error;
    }
  },

  getSkillByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SKILLS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching skill ${identifier}:`, error);
      throw error;
    }
  },

  createSkill: async (skillData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SKILLS}`, skillData);
      return response.data;
    } catch (error) {
      console.error('Error creating skill:', error);
      throw error;
    }
  },

  updateSkill: async (identifier, skillData) => {
    try {
      skillData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.SKILLS}/${identifier}`, skillData);
      return response.data;
    } catch (error) {
      console.error(`Error updating skill ${identifier}:`, error);
      throw error;
    }
  },

  trashSkill: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.SKILLS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing skill ${identifier}:`, error);
      throw error;
    }
  },

  restoreSkill: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SKILLS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring skill ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteSkill: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.SKILLS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting skill ${identifier}:`, error);
      throw error;
    }
  },
};

export default skillApi;